module.exports = __webpack_public_path__ + "static/media/casagiardinoBanner.8bb82cab.png";